//NAV
(function() {

    const fixedHeader = 'wpk-header-sticky';
    const headerMain = document.getElementById('header-main');
    const bodyTarget = document.querySelector('body');
    const navOptions = { rootMargin: '0px', threshold: 0 };
    let navObserver;

    //From customizer
    const stickyHeader = document.querySelector('header.wpk-sticky-header') !== null; //Returns true if so

    if(stickyHeader) {

        //If we have newer browsers
        if (('IntersectionObserver' in window)) {

            //Call function
            navObserver = new IntersectionObserver(onNavIntersection, navOptions);
            
            //Run function for nav selector
            navObserver.observe(headerMain);
        }

    }

    //function for running observer
    function onNavIntersection(entries) {
        // Loop through the entries
        entries.forEach(entry => {
            //If we are in viewport
            if (entry.intersectionRatio > 0) {
                bodyTarget.classList.remove(fixedHeader);
            } else {
                //Get wrapper height (live)
                //const headerHeight = headerMain.querySelector('.wrapper').offsetHeight;
                //Set header height to avoid skipping
                //headerMain.style.height = headerHeight + 'px';
                //Set header height to position fixed
                bodyTarget.classList.add(fixedHeader);
                
            }
        });
    }

    //Stop BODY from scrolling (on small screens only)
    //There is also a inline script that removes the .wpk-header-scroll class on window.onpageshow for mobile devices cache function
    const navCheckbox = document.getElementById('main-nav-checkbox');
    if(navCheckbox) {
        navCheckbox.addEventListener('click', function(event) {
            if(event.target.checked == true) {
                bodyTarget.classList.add('wpk-header-scroll');
            } else {
                bodyTarget.classList.remove('wpk-header-scroll');
            }
        });
    }

})();